import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { IPaginationQueryInfo } from 'types/pagination'
import { IProcurement, IProcurements } from 'types/procurements/index'

type TProcumenrentSearchParams = IPaginationQueryInfo & { lotId?: string }
type TProcurementIdParams = IdParams & { procurementId?: string }

export const procurementsApi = createApi({
  reducerPath: 'procurements',
  tagTypes: ['ProcurementItems'],
  baseQuery,
  endpoints: (builder) => ({
    procurementsSearch: builder.query<IProcurements, TProcumenrentSearchParams>({
      query: (params) => ({
        url: '/procurements/search',
        params,
      }),
      providesTags: ['ProcurementItems'],
    }),
    createProcurement: builder.mutation<IProcurement, Partial<IProcurement>>({
      query: (body) => ({
        url: `/procurements/${body.procurementRequirementId}/items`,
        method: 'post',
        body,
      }),
      invalidatesTags: ['ProcurementItems'],
    }),
    deleteProcurement: builder.mutation<void, TProcurementIdParams>({
      query: ({ id, procurementId }) => ({
        url: `/procurements/${procurementId}/items/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['ProcurementItems'],
    }),
  }),
})

export const {
  useProcurementsSearchQuery,
  useCreateProcurementMutation,
  useDeleteProcurementMutation,
} = procurementsApi
